{
  "energiebe": {
    "url": "https://tc.tradetracker.net/?c=34765&m=12&a=514266&r=energiebe&u=",
    "network": "tradetracker",
    "campaign_id": "34765",
    "campaign": "Energie.be"
  },
  "energy-knights": {
    "url": "https://www.energyknights.be/tracking/?tt=39067_12_514266_energy-knights&r=",
    "network": "tradetracker",
    "campaign_id": "39067",
    "campaign": "Energyknights.be"
  },
  "mega": {
    "url": "https://www.mega.be/nl/energie/energy-is-cheap?tt=38850_12_514266_mega&r=",
    "network": "tradetracker",
    "campaign_id": "38850",
    "campaign": "Mega.be"
  },
  "octaplus": {
    "url": "https://octaplus.be/energie/?tt=8674_12_514266_octaplus&r=",
    "network": "tradetracker",
    "campaign_id": "8674",
    "campaign": "Octaplus.be"
  }
}
